document.addEventListener('DOMContentLoaded', function() {

    //variables 
    var viewport = document.documentElement.clientWidth;
    var nav = document.querySelector('.navbar');
    var header = document.querySelector('.header-container');
    var togglerOpen = document.querySelector('.navbar-toggler');
    var togglerClose = document.querySelector('.navbar-toggler-close');
    var toggle = document.querySelector('#toggle'); 

    //listeners
    togglerOpen.addEventListener('click', openMenu);
    togglerClose.addEventListener('click', closeMenu);
    window.addEventListener('scroll', headerChanges);

    //functions   
    function openMenu() {
        toggle.classList.add('show');
        if(viewport < 960){
            header.classList.add('is-open'); 
        }
    }

    function closeMenu() {
        toggle.classList.remove('show'); 
        if(viewport < 960){
            header.classList.remove('is-open'); 
        }
    } 

    function headerChanges() {

        var scroll = $(window).scrollTop();
        var slideActive = $('#carousel.carousel-home .active');   

        if (scroll >= 78) {

            nav.classList.add('sticky');
            header.classList.remove('is-dark');

        } else if (scroll < 78 && slideActive.hasClass('dark') && viewport > 480) {

            header.classList.add('is-dark');
            nav.classList.remove('sticky');

        } else {

            nav.classList.remove('sticky');

        } 

    } 

    $(".btn-qty").on("click", function() {

        var $button = $(this);
        var oldValue = $button.parent().find(".qty").val();

        if ($button.text() == "+") {
            var newVal = parseFloat(oldValue) + 1;
        } else { 
            if (oldValue > 0) {
                var newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 0;
            }
        }

        $button.parent().find(".qty").val(newVal);

    });
    
    $('.shopping-cart-btn, .add-to-cart').on('click', function(){

        $('.note-trigger')[0].click(); 

    });

});
